import React, { FC } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Global } from '@emotion/react';
import { GlOBAL_RESET_CSS } from './styles/reset';
import { GlOBAL_COMMON_CSS } from './styles/common';
import { GlOBAL_VISIT_CSS } from './styles/visitor-existing';
// import './styles/visitor-existing.scss';
import ReservationHistory from './pages/ReservationHistory/ReservationHistory.index';
import ReservationHistoryDetail from './pages/ReservationHistory/Detail/ReservationHistoryDetail.index';
import ReservationCancelComplete from './pages/ReservationHistory/Detail/Modal/ReservationCancel/Complete/ReservationCancelComplete.index';
import ShopList from './pages/ShopList/ShopList.index';
import Schedule from './pages/Schedule/Schedule.index';
import VisitorRegister from './pages/VisitorRegister/VisitorRegister.index';
import VisitorRegisterConfirm from './pages/VisitorRegister/Confirm/VisitorRegisterConfirm.index';
import SimpleAuth from './pages/SimpleAuth/SimpleAuth.index';
import RegisterComplete from './pages/RegisterComplete/RegisterComplete.index';

import ErrorSystem from './pages/Error/ErrorSystem';
import Error404 from './pages/Error/Error404';

// const loading = (
//   <div className="pt-3 text-center">
//     <div className="sk-spinner sk-spinner-pulse" />
//   </div>
// );

const App: FC = () => {
  return (
    <>
      <Global styles={GlOBAL_RESET_CSS} />
      <Global styles={GlOBAL_COMMON_CSS} />
      <Global styles={GlOBAL_VISIT_CSS} />
      <BrowserRouter>
        <Switch>
          {/* <Route path="/" component={ShopList} exact /> */}
          {/* <Redirect exact from="/" to="/visitor-reservation" /> */}

          <Route path="/systemError" component={ErrorSystem} />

          {/* 予約の画面 - 店舗一覧 */}
          <Route path="/" component={ShopList} exact />
          {/* 予約履歴の画面 */}
          <Route path="/history" component={ReservationHistory} exact />
          <Route path="/history/detail" component={ReservationHistoryDetail} exact />
          <Route path="/history/detail/cancel-complete" component={ReservationCancelComplete} exact />

          <Route path="/reservation/schedule" component={Schedule} exact />
          <Route path="/register" component={VisitorRegister} exact />
          <Route path="/register/confirm" component={VisitorRegisterConfirm} exact />
          <Route path="/simpleAuth" component={SimpleAuth} exact />
          <Route path="/register/complete" component={RegisterComplete} exact />

          <Route path="*" component={Error404} />
        </Switch>
      </BrowserRouter>
    </>
  );
};

export default App;
